module.exports = __webpack_public_path__ + "img/Monte_Kope_21.c2ae37c2.jpg";